module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-afl50-mobile.0f4f2f59.jpg";